import { FC, useContext, useEffect, useRef } from "react";
import { useUserPreferences } from "src/hooks/useUserPreferences";
import { AppCtx } from "src/contexts/app.context";

const UserPreferences: FC = () => {
  const { data, loading } = useUserPreferences();
  const { setUserPreferences } = useContext(AppCtx);
  const isUserPreferencesSetRef = useRef(false);

  useEffect(() => {
    if (!data || loading || isUserPreferencesSetRef.current) {
      return;
    }
    setUserPreferences(data?.userPreferences || data?.userPreferencesByEmail);
    isUserPreferencesSetRef.current = true;
  }, [setUserPreferences, data, loading]);

  return <></>;
};

export default UserPreferences;
